<template>
  <div>
    <scroller ref="scroller">
      <header class="header" :class="{height: isWechat}">
        <div class="topbar">
          <router-link class="btn-setting iconfont" to="/user/settings" :class="{iconTop: isWechat}"></router-link>
          <h1 class="topbar-title" v-if="visible">我的</h1>
        </div>
        <!--<p class="label" :class="{labelTop: isWechat}">借款总额/元</p>-->
        <!--<h4 class="decimal" :class="{cellTop: isWechat}">{{sumIntger}}<small>.{{sumDecimal}}</small></h4>-->
        <!--<ul class="cells" :class="{cellTop: isWechat}">-->
          <!--<li class="cell">-->
            <!--<p class="label">已还金额/元</p>-->
            <!--<h5 class="decimal">{{yfInteger}}<small>.{{yfDecimal}}</small></h5>-->
          <!--</li>-->
          <!--<li class="cell">-->
            <!--<p class="label">待还金额/元</p>-->
            <!--<h5 class="decimal">{{dfInteger}}<small>.{{dfDecimal}}</small></h5>-->
          <!--</li>-->
        <!--</ul>-->
      </header>
      <section class="section-title" v-show="orderList.length !== 0">
        <h4 class="caption">我的业务单</h4>
      </section>
      <div class="content-padded">
        <ul class="card-group" v-show="orderList.length !== 0">
          <li class="card-item" v-for="(item, index) in orderList" @click="onItemClick(index)" :key="index">
            <span class="status">{{item.statusName}}</span>
            <h4 class="name">{{item.productName}}</h4>
            <div class="small"><span>{{item.no}}</span></div>
            <p class="date">签约日期：{{item.signDate}}</p>
          </li>
        </ul>
      </div>
      <div class="no-order" v-show="orderList.length === 0 && !loading">
        <div class="msg">
          暂无借款订单
        </div>
        <div class="btn"><router-link to="/borrow">立即申请借款</router-link></div>
      </div>
    </scroller>
    <spinner :show="loading"></spinner>
  </div>
</template>

<script>
  import accounting from 'accounting'
  import Scroller from 'components/scroller/scroller'
  import Spinner from 'components/spinner/spinner'

  export default {
    data () {
      return {
        loading: false,
        orderList: [],
        sumAmount: 0,
        yfAmount: 0,
        dfAmount: 0,
        visible: false,
        isWechat: false
      }
    },
    components: {
      Scroller,
      Spinner
    },
    created () {
      this.visible = !this.$device.isWechat
      if (this.$device.isWechat) {
        this.isWechat = true
      }
    },
    computed: {
      sumIntger () {
        return accounting.formatMoney(this.sumAmount, '').split('.')[0]
      },
      sumDecimal () {
        return accounting.formatMoney(this.sumAmount, '').split('.')[1]
      },
      yfInteger () {
        return accounting.formatMoney(this.yfAmount, '').split('.')[0]
      },
      yfDecimal () {
        return accounting.formatMoney(this.yfAmount, '').split('.')[1]
      },
      dfInteger () {
        return accounting.formatMoney(this.dfAmount, '').split('.')[0]
      },
      dfDecimal () {
        return accounting.formatMoney(this.dfAmount, '').split('.')[1]
      }
    },
    mounted () {
      this.token = this.$cache.getUserToken()
      this._fetchStatic()
      this._fetchData()
    },
    watch: {
      token (val) {
        if (val && val.uid && val.mac) {
          this._fetchStatic()
          this._fetchData()
        }
      }
    },
    methods: {
      _fetchStatic () {
        let vm = this
        this.$ajax({
          url: '/center/getUserInfo.jhtml',
          params: {
            uid: vm.token.uid
          },
          done (info) {
            vm.sumAmount = info.sumAmount
            vm.yfAmount = info.yfAmount
            vm.dfAmount = info.dfAmount
          }
        })
      },
      _fetchData () {
        if (this.token) {
          let vm = this
          let params = {
            isPage: 'y',
            pageNumber: 1,
            pageSize: 10,
            uid: this.token.uid
          }
          this.loading = true
          this.$ajax({
            url: '/center/getOrderList.jhtml',
            params,
            done (list, page) {
              vm.orderList = list
              vm._refresh()
            },
            fail (msg) {
              vm.$dialog(msg)
            },
            always () {
              vm.loading = false
            }
          })
        }
      },
      _refresh () {
        this.$nextTick(() => {
          if (this.$refs.scroller) {
            setTimeout(() => {
              this.$refs.scroller.resize()
            }, 500)
          }
        })
      },
      onItemClick (index) {
        let item = this.orderList[index]
        this.$router.push(`/user/order/${item.no}/detail?isFbs=${item.isFbs}&isFI=${item.isFI}`)
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'

  ul, li
    padding 0
    margin 0
    list-style-type none
  .height
    height px2rem(240px)
  .header
    position relative
    z-index 100
    color #fff
    text-align center
    overflow hidden
    background url(../../../static/images/bg-header.png) no-repeat top left
    background-size 100% auto
    .topbar
      position relative
      padding 0 px2rem(10px)
      height px2rem(88px)
      overflow hidden
      .topbar-title
        position absolute
        left 40px
        right 40px
        height 100%
        margin 0
        font-size px2rem(32px)
        letter-spacing px2rem(2)
        font-weight normal
        line-height px2rem(88px)
      .btn-setting
        float right
        padding 0 10px
        font-size px2rem(36px)
        line-height px2rem(88px)
        color @color
        &:before
          content '\e600'
    .label
      margin 0
      color #12aaeb
    .decimal
      margin 0
      font-weight 300
    small
      line-height 1
    & > .label
      margin px2rem(3px) 0
      font-size px2rem(30px)
      line-height px2rem(30px)
    & > .decimal
      font-size px2rem(72px)
      line-height px2rem(72px)
      small
        font-size px2rem(36px)
    .cells
      display table
      width 100%
      margin px2rem(20px) 0
      .cell
        display table-cell
        width 50%
        &:last-child
          border-left px2rem(4px) dotted #12aaeb
        .label
          font-size px2rem(24px)
          margin-bottom px2rem(6px)
        .decimal
          font-size px2rem(34px)
          small
            font-size px2rem(24px)
  .content-padded
    margin 0 px2rem(20px)
  .card-group
    padding-bottom 1px
    .card-item
      position relative
      padding px2rem(30px) px2rem(20px) px2rem(60px)
      margin-bottom px2rem(20px)
      font-size px2rem(28px)
      line-height 1
      background-color #fff
      border-radius px2rem(10px)
      box-shadow 0 5px 15px #abb9c5
      &:after
        content ''
        position absolute
        bottom px2rem(50px)
        left 0
        right 0
        height 1px
        background-color rgb(247, 247, 247)
      .status
        position absolute
        right 0
        top px2rem(20px)
        padding px2rem(8px)
        padding-left px2rem(30px)
        color #fff
        letter-spacing px2rem(2)
        background linear-gradient(to left,#f66468,#ef825d)
        border-top-left-radius px2rem(30px)
        border-bottom-left-radius px2rem(30px)
      .name
        margin 0 px2rem(120px) px2rem(30px) 0
        font-size px2rem(32px)
        font-weight 700
        color #275482
      .small
        margin px2rem(10px) 0
        span
          display inline-block
          padding px2rem(4px) px2rem(10px)
          color #3a80ec
          border 1px solid #3a80ec
          border-radius px2rem(20px)
      .date
        position absolute
        bottom px2rem(10px)
        right 0
        margin 0 px2rem(20px) 0 0
        color rgb(78, 70, 90)
        text-align right
      .decimal
        font-size 120%
  .header
    .iconTop
      position relative
      top px2rem(-8px)
    .labelTop
      position relative
      top px2rem(-72px)
    .cellTop
      position relative
      top px2rem(-66px)
  .no-order
    padding px2rem(100px)
    .msg
      line-height px2rem(200px)
      text-align center
      font-size px2rem(32px)
    .btn
      width 80%
      margin 0 auto
      background-color #60c9c8
      box-shadow 0 0 px2rem(4px) rgba(18,119,163, .75)
      text-align center
      line-height px2rem(80px)
      height px2rem(80px)
      font-size px2rem(32px)
      border none
      border-radius px2rem(8px)
      letter-spacing px2rem(4)
      a
        display block
        color #fff
</style>



// WEBPACK FOOTER //
// user.vue?42ee36ec